export default { DefaultTimeout: 30 * 1000 /* 30 seconds */, ContentApiTimeout: 10 * 1000 };

export const NotFound = '404';

export enum ErrorCodes {
    Unknown = 0,
    MissingUserData = 1,
    InternalServerError = 2,
}
